





































































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
// 定数ファイル
import { Constants } from '../../CommonUtils/fixed/Constants';
import { Message } from '../../CommonUtils/fixed/Message';
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';
// 共通モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { applicationFormModule } from '../store/modules/ApplicationForm';
import { partialInfoModule } from '../store/modules/PartialInfo';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class PartialInfoMajorCategory extends ApiAccessBase {
  private municipalName = '';
  private credentName = '';
  private APP_PATH = Constants.UKETSUKE_URL + '/partial/' + applicationFormModule.GET_APP_TYPE;

  private created() {
    this.screenTitle = '個別情報登録（物品・役務）大分類';
    // モジュールに現在の画面を記録
    routingControlModule.registCurrent(this.$route.name);
    this.municipalName = partialInfoModule.GET_MUNICIPAL;
    this.credentName = partialInfoModule.GET_CREDENT_NAME;

    let path = this.APP_PATH;
    path = path + '/major/' + applicationFormModule.GET_PROCESS_TYPE;
    path = path + '/' + applicationFormModule.GET_TRADER_ID + '/' + applicationFormModule.GET_MUNICIPAL + '/' + partialInfoModule.GET_CREDENT;

    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, true, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
        }
      },
    );
  }
  /**
   * 中小分類画面に遷移
   */
  private toMeisai(code: string, name: string) {
    partialInfoModule.setMajorCategory(code);
    partialInfoModule.setMajorCategoryName(name);
    router.push({name: UketsukeScreenName.PARTIAL_INFO_GOODS});

  }
  /**
   * 戻る
   */
  private returnPrevious() {
    // if (confirm(Message.I0014)) {
      router.push({name: UketsukeScreenName.PARTIAL_INFO_CREDENTIALS});
    // }
  }
}
